import { useUIContext } from 'lib/context/UIContext/UIContext';
import { cn, snakeToTitleCase } from 'lib/helpers/utility';

import Dot from 'components/shared/Dot/Dot';
import Typography from 'components/shared/Typography/Typography';

const ServiceDetails = ({ service }) => {
  const { device } = useUIContext();
  const isMobile = device === 'mobile' || device === 'tablet-sm';

  return (
    <div className={cn('flex w-full flex-col gap-2.5', isMobile && '-mb-4')}>
      {service?.name && (
        <Typography variant="label" size="medium" weight="medium">
          {service?.name}
        </Typography>
      )}
      <div className="flex items-center gap-2">
        {service?.procedure_code && (
          <Typography variant="p" size="xs" color="neutral-700">
            CPT® Code: {service?.procedure_code}
          </Typography>
        )}
        {service?.procedure_code && service?.type && (
          <Dot size="xs" color="neutral" className="!bg-transparent shadow-none" />
        )}
        {service?.type && (
          <Typography variant="p" size="xs" color="neutral-700">
            {snakeToTitleCase(service?.type)}
          </Typography>
        )}
        {(service?.procedure_code || service?.type) && (
          <Dot size="xs" color="neutral" className="!bg-transparent shadow-none" />
        )}
        <Typography variant="p" size="xs" color="neutral-700">
          {'procedure_code' in (service || {}) && 'type' in (service || {})
            ? 'Service'
            : 'procedure_code' in (service || {})
              ? 'Package'
              : 'Product'}
        </Typography>
      </div>
    </div>
  );
};

export default ServiceDetails;
